import { useRBACCheck } from "@hooks:useRBAC";
import { Box } from "@mui/material";
import { Profile } from "@pages:settings/Account/Profile";
import { UiBranding } from "@pages:settings/Preferences/UiBranding/UiBranding";
import { UiPreferences } from "@pages:settings/Preferences/UiPreferences/UiPreferences";
import { SettingsSidebar } from "@pages:settings/SettingsSidebar";
import { Bots } from "@pages:settings/Tenent/Bots/Bots";
import { Organizations } from "@pages:settings/Tenent/Organizations/Organizations";
import { Users } from "@pages:settings/Tenent/Users/Users";
import { useMemo } from "react";
import { Navigate, useLocation } from "react-router";

import { Routes } from "@:constants";
import { RBACAction, RBACResource } from "@:rbac";

export const Settings = () => {
  const { pathname } = useLocation();

  const canAccessProfile = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__profile"],
  );
  const canAccessOrganizations = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__organizations"],
  );
  const canAccessUsers = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__users"],
  );
  const canAccessBots = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__bots"],
  );
  const canAccessUiPreferences = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__ui_preferences"],
  );
  const canAccessUiBranding = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__ui_branding"],
  );

  const renderRightSide = useMemo(() => {
    switch (pathname) {
      case Routes.SettingsProfile:
        return canAccessProfile ? (
          <Profile />
        ) : (
          <Navigate to={Routes.NotFound} />
        );
      case Routes.SettingsOrganizations:
        return canAccessOrganizations ? (
          <Organizations />
        ) : (
          <Navigate to={Routes.NotFound} />
        );
      case Routes.SettingsUsers:
        return canAccessUsers ? <Users /> : <Navigate to={Routes.NotFound} />;
      case Routes.SettingsBots:
        return canAccessBots ? <Bots /> : <Navigate to={Routes.NotFound} />;
      case Routes.SettingsUiPreferences:
        return canAccessUiPreferences ? (
          <UiPreferences />
        ) : (
          <Navigate to={Routes.NotFound} />
        );
      case Routes.SettingsUiBranding:
        return canAccessUiBranding ? (
          <UiBranding />
        ) : (
          <Navigate to={Routes.NotFound} />
        );
      default:
        return <Navigate to={Routes.NotFound} />;
    }
  }, [
    pathname,
    canAccessProfile,
    canAccessOrganizations,
    canAccessUsers,
    canAccessBots,
    canAccessUiPreferences,
    canAccessUiBranding,
  ]);

  return (
    <Box
      className="Settings"
      sx={{
        display: "flex",
        flexDirection: "row",
        height: "100%",
        backgroundColor: (theme) => theme.palette.background.sidebar,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100dvh",
          padding: "10px",
        }}
      >
        <SettingsSidebar />
      </Box>

      <Box
        sx={{
          flex: 1,
          backgroundColor: (theme) => theme.palette.common.white,
          overflow: "auto",
          marginLeft: 0,
        }}
      >
        {renderRightSide}
      </Box>
    </Box>
  );
};
